import { render, staticRenderFns } from "./upload-vr.vue?vue&type=template&id=2d061c12&scoped=true&"
import script from "./upload-vr.vue?vue&type=script&lang=js&"
export * from "./upload-vr.vue?vue&type=script&lang=js&"
import style0 from "./upload-vr.vue?vue&type=style&index=0&id=2d061c12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d061c12",
  null
  
)

export default component.exports